module.exports = "<igo-list [navigation]=\"false\" [selection]=\"false\">\r\n  <ng-template ngFor let-datasource [ngForOf]=\"datasources | filterableDataSource: 'ogc'\">\r\n    <igo-ogc-filterable-item igoListItem [ogcFiltersHeaderShown]=\"true\" [datasource]=\"datasource\"></igo-ogc-filterable-item>\r\n  </ng-template>\r\n  <ng-content></ng-content>\r\n</igo-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/filter/ogc-filterable-list/ogc-filterable-list.component.html
// module id = 1034
// module chunks = 0